/**
 * QC Result Mapper -- chuyen QC result (server format) sang AuditDetails (frontend format).
 * 
 * Logic nay truoc bi trung lap o 2 cho:
 * - useTranslateWorkflow.ts (line 223-254)
 * - App.tsx handleRunQualityCheck (line 409-440)
 * 
 * Tach ra day de dung chung.
 */

export interface AuditDetailsFromQC {
  overallScore: number;
  componentScores: {
    accuracy: number;
    terminology: number;
    tone: number;
    fluency: number;
    completeness: number;
    style: number;
  };
  segmentMappings: Array<{
    sourceIndex: number;
    humanIndices: number[];
    isMissing: boolean;
    score: number;
    rules: string;
    errors: string;
    reviews: string;
    notes: string;
    issues: string;
    suggestions: string;
  }>;
  criticalErrors: any[];
  glossaryRules: any[];
  accuracyAnalysis: string;
  fluencyAnalysis: string;
  completenessAnalysis: string;
  terminologyAnalysis: string;
  toneAnalysis: string;
  suggestedPromptUpdate: string;
  isTruncated: boolean;
}

/**
 * Map QC result tu server sang AuditDetails format cua frontend.
 */
export function mapQCResultToAuditDetails(qcResult: any): AuditDetailsFromQC {
  const scores = qcResult.scores || {};
  const segments = qcResult.segments || [];
  const evaluation = qcResult.evaluation || {};

  return {
    overallScore: scores.overall || 0,
    componentScores: {
      accuracy: scores.accuracy || 0,
      terminology: scores.terminology || 0,
      tone: scores.style || 0,
      fluency: scores.fluency || 0,
      completeness: scores.completeness || 0,
      style: scores.style || 0,
    },
    segmentMappings: segments.map((seg: any) => ({
      sourceIndex: seg.sourceIndex,
      humanIndices: [],
      isMissing: false,
      score: seg.score,
      rules: '',
      errors: '',
      reviews: '',
      notes: seg.original || '',
      issues: seg.issues || '',
      suggestions: seg.suggestion || '',
    })),
    criticalErrors: [],
    glossaryRules: [],
    accuracyAnalysis: evaluation['accuracy'] || '',
    fluencyAnalysis: evaluation['fluency'] || '',
    completenessAnalysis: evaluation['completeness'] || '',
    terminologyAnalysis: evaluation['terminology'] || '',
    toneAnalysis: evaluation['style'] || '',
    suggestedPromptUpdate: qcResult.summary || '',
    isTruncated: false,
  };
}
